import { gql, TypedDocumentNode } from "@apollo/client";

import type {
  MutationRunExternalDependencyMarkAsCompletedArgs,
  RunExternalDependencyMarkAsCompletedResponse,
} from "types/generated";

type FetchRunExternalDependencyMarkAsCompletedData = {
  runExternalDependencyMarkAsCompleted: Pick<
    RunExternalDependencyMarkAsCompletedResponse,
    "status"
  >;
};
export const RUN_EXTERNAL_DEPENDENCY_MARK_AS_COMPLETED: TypedDocumentNode<
  FetchRunExternalDependencyMarkAsCompletedData,
  MutationRunExternalDependencyMarkAsCompletedArgs
> = gql`
  mutation RunExternalDependencyMarkAsCompleted(
    $dependency: ID!
    $status: RunExternalDependencyStatus!
  ) {
    runExternalDependencyMarkAsCompleted(dependency: $dependency, status: $status) {
      status
    }
  }
`;
